module.exports = __webpack_public_path__ + "img/flowEcology.de3a36b2.png";